<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div v-if="DeactiveSuccess === true">
              <CAlert color="danger">Success !</CAlert>
            </div>

            <div class="text-center">
              <span>
                <img
                v-if="childProfileAuthorize.studentFilePath == null"
                src="../../assets/img/icon/icondefault.svg"
                style="max-width: -webkit-fill-available"
              />
              <img
                v-else
                width="100px"
                height="100px"
                :src="photoURL"
                style="border-radius: 50%; border: 5px solid #fff"
              />
              </span>
              <div>
                <img src="../../assets/img/icon/imgCamera.svg" class="ml-5" @click="OpenUploadPopup()"/>
              </div>
              <div class="title mt-4" style="color: #000a2c">Profile Image</div>
            </div>

            <div class="list-grade" @click="GoToChangeName(students.studentNickname, students.id)">
              <div class="float-left">
                <label class="ml-3">Student Nickname</label>
                <br />
                <label class="ml-3 sub-title-card text-black">
                  {{ students.studentNickname }}
                </label>
              </div>
              <div class="float-right">
                <img class="mt-3" src="../../assets/img/icon/VectorRight.svg" />
              </div>
              <div style="clear: both"></div>
              <hr />
            </div>

            <div class="list-grade" @click="GoToChangeGrade(students.gradeName, students.id)">
              <div class="float-left">
                <label class="ml-3">Grade</label>
                <br />
                <label class="ml-3 sub-title-card text-black">{{
                  students.gradeName
                }}</label>
              </div>
              <div class="float-right">
                <img class="mt-3" src="../../assets/img/icon/VectorRight.svg" >
              </div>
              <div style="clear: both"></div>
              <hr />
            </div>

            <div class="list-grade" @click="GoToChangeExam(students.examShortName, students.id, students.examId)">
              <div class="float-left">
                <label class="ml-3">Exam Taken</label>
                <br />
                <label class="ml-3 sub-title-card text-black">{{
                  students.examShortName
                }}</label>
              </div>
              <div class="float-right">
                <img
                  class="mt-3"
                  src="../../assets/img/icon/VectorRight.svg"
                  
                />
              </div>
              <div style="clear: both"></div>
              <hr />
            </div>

            <div class="list-grade" @click="GoToAddMoreSubject(students.id)">
              <div class="float-left">
                <label class="ml-3">Focused Subject</label>
                <br />
                <label
                  v-for="item in students.focusSubject"
                  :key="item.Id"
                  :index="item.Id"
                  class="ml-3 sub-title-card text-black"
                  >{{ item.subjectName }},</label
                >
              </div>
              <div class="float-right">
                <img class="mt-3" src="../../assets/img/icon/VectorRight.svg" >
              </div>
              <div style="clear: both"></div>
              <hr />
            </div>
            
            <div class="list-grade">
              <div class="float-left">
                <label class="ml-3">Educational institutions</label>
                <br />
                <label class="ml-3 sub-title-card text-black">{{
                  students.tuitionCenterName
                }}</label>
              </div>
              <!-- <div class="float-right">
                <img
                  class="mt-3"
                  src="../../assets/img/icon/VectorRight.svg"
                  @click="
                    GoToChangeExam(
                      students.examShortName,
                      students.id,
                      students.examId
                    )
                  "
                />
              </div> -->
              <div style="clear: both"></div>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="bottom-center">
      <CButton class="custom-btn-deactive mt-5" @click="OpenDeactivePopup()"
        >Deactivate Account</CButton
      >
    </div>
    <div class="header-top">Manage {{ students.studentNickname }}</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
    <CModal size="md" :show.sync="DeactiveModal">
      <div class="text-center">
        <h3 class="custom-title-popup" style="color: #000a2c">
          Deactive Student
        </h3>
        <br />
      </div>
      <div class="text-center">
        <h4 class="sub-title-header" style="color: #000a2c">
          Are you sure to remove {{ students.studentNickname }} ? All of<br />
          {{ students.studentNickname }} data will be removed.
        </h4>
        <br />
      </div>
      <div class="text-center">
        <CButton class="btn-select-blue mt-5">No, I Change My Mind</CButton>
      </div>
      <div class="text-center">
        <CButton class="btn-select-white mt-2" @click="DeactiveStudent()"
          >Yes, Remove {{ students.studentNickname }}</CButton
        >
      </div>
    </CModal>
    <div style="clear: both"></div>

    <CModal size="md" :show.sync="UploadModal">
      <div class="text-center">
        <h3 class="custom-title-popup" style="color: #000a2c">
          Upload New Profile Image
        </h3>
        <br />
      </div>
      <div class="text-center">
        <input type="file" id="file" ref="file" accept="image/jpeg" v-on:change="handleFileUpload()">
        <br />
      </div>
      <template #footer>
        <CButton type="submit" color="info" class="p-2" @click="UpdateProfileImage"
          >Upload</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DeactiveModal: false,
      UploadModal: false,
      DeactiveSuccess: false,
      students: [],
      user: {},
      childProfileAuthorize: "",
      childs: [],
      parent: [],
      StudentId: this.$route.query.studentId,
    };
  },

  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            // this.GetAuthorizeProfile(this.user.id);
            this.GetListChild(this.user.id);
            this.GetParentDetail(this.user.id);
            this.GetProfileStudentsByStudentId();
            this.GetStudentPhotoAuthorize();
          }
        });
    },

    GetProfileStudentsByStudentId() {
      this.$API
        .get(
          this.$GetStudentDetailByStudentId +
            "?studentId=" +
            this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });
    },

    // GetAuthorizeProfile() {
    //   this.$API
    //     .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.studentProfileAuthorize = response.data;
    //         this.photoURL =
    //           "https://pickiddo.com" + this.studentProfileAuthorize;
    //       }
    //     });
    // },

    GetStudentPhotoAuthorize() {
      this.$API
        .get(
          this.$GetStudentPhotoAuthorize +
            "?studentId=" +
            this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" +
              this.childProfileAuthorize.studentFilePath;
          }
        });
    },

    GetListChild() {
      this.$API
        .get(this.$ListChild + "?userID=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childs = response.data;
          }
        });
    },

    GetParentDetail() {
      this.$API
        .get(this.$GetParentDetailByUserId + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parent = response.data;
          }
        });
    },

    OpenDeactivePopup() {
      this.DeactiveModal = true;
    },

    OpenUploadPopup() {
      this.UploadModal = true;
    },

    GoToChangeName(studentNickname) {
      this.$router.push(
        "ChangeName?studentNickname=" +
          studentNickname +
          "&studentId=" +
          this.$route.query.studentId
      );
    },

    GoToChangeGrade(gradeName) {
      this.$router.push(
        "ChangeGrade?gradeName=" +
          gradeName +
          "&&studentId=" +
          this.$route.query.studentId
      );
    },

    GoToChangeExam(examShortName, examId) {
      this.$router.push(
        "ChangeExam?examShortName=" +
          examShortName +
          "&&studentId=" +
          this.$route.query.studentId +
          "&&examId=" +
          examId
      );
    },

    GoToAddMoreSubject() {
      this.$router.push(
        "AddMoreSubjects?studentId=" + this.$route.query.studentId
      );
    },

    DeactiveStudent: function () {
      const formData = new FormData();
      formData.append("id", this.$route.query.studentId);
      // formData.append("status", "inactive");

      return this.$API
        .post(this.$DeactivateStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            
            this.DeactiveModal = false;
            this.GoToManageStudent();
            this.DeactiveSuccess = true;
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to deactive").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    GoToManageStudent() {
      this.$router.push("/ParentProfile/ManageStudents");
    },

    GoBack() {
      this.$router.back();
    },

    UpdateProfileImage: function () {
      const formData = new FormData();
      formData.append('image', this.file);
      formData.append("studentId", this.StudentId);

      return this.$API
        .post(this.$UpdateStudentProfileImage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Success save").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    uploadImage(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                    this.previewImage = e.target.result;
                    console.log(this.previewImage);
                }
    },
    
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      console.log(this.file);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #ffffff;

  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}
.custom-btn-add {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;

  color: #007cef;
}
.custom-btn-deactive {
  position: absolute;
  left: 0%;
  right: 0.61%;
  top: 0%;
  bottom: 0%;

  /* Body/1/Semibold */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  /* identical to box height, or 24px */

  color: #f85954;
}
.custom-text-deactive {
  position: absolute;
  width: 162px;
  height: 22px;
  left: 107px;
  top: 25px;

  /* Title/1/Semibold */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  text-align: center;

  /* Black/Dark-001 */

  color: #000a2c;
}
</style>